import * as Sentry from "@sentry/react";
import generate_random_string from "./random_generator";
import { NetworkError } from "./errors";

//General purpose fetch  
const general_fetch = async ({ url, full_url, method, headers, body, is_form_data, credentials, data_field, req_resp, return_raw_response, return_response_code }) => {
	try {
		if (!data_field) {
			data_field = 'data';
		}
		if (full_url) {
			url = full_url;
		} else {
			url = global.config.server_path + url;
		}
		if (!url) {
			throw 'invalid url provided';
		}
		if(!method) {
			method = 'POST';
		}
		if (!is_form_data) {
			if (!headers && full_url != 'https://ipapi.co/json/') {
				headers = {
					'Content-Type': 'application/json',
					'x-request-id': generate_random_string()
				};
			}
			if (body) {
				body = JSON.stringify(body);
			}
		}
		if (!credentials) {
			credentials = 'include';
		}
		
        var options = { method, headers, credentials, body };
        //console.log("options======>" , options)
		let retries = 3;
        let delay = 1000;

        try {
            var resp;
            for (let i = 0; i < retries; i++) {
				let step = 0;
				try{
					step = 0;
					resp = await fetch(url, options);
					step = 1;
					resp = await resp.json();
					break;
				}catch(err){

					console.log("Network Error- ", url, resp, headers ? headers["x-request-id"] : '-')
					if (i < retries - 1) {
                        await new Promise(res => setTimeout(res, delay));
                    } else {
						throw new Error(step === 0 ? "Network Error, Failed to fetch" : "Network Error, non json response ")
					}
				}
			}
		}catch(err){
			throw err
		}

		if(resp && resp.code === 'SCHEDULED_MAINTAINANCE'){
			// console.log('set_downtime_var')
			global.set_downtime_var(true)
		}

		if(req_resp || return_raw_response || return_response_code){
			return resp;
		}
        if (resp.response_code == 1 || resp.response_code == 0) {
        	return resp[data_field];
        } else {
        	throw new Error('Server call failed with response ---> ' + JSON.stringify(resp));
        }
	} catch(err) {
		console.log('set_downtime_var', resp)
		if(resp && resp.code === 'SCHEDULED_MAINTAINANCE') {
			// console.log('set_downtime_var')
			global.set_downtime_var(true)
		} else if((resp && resp.status===401) || (resp && resp.response_code == 401) || (global.config.server_path+'/user/get_details' == url && resp.is_authenticated == false)) {
			// global.config.check_401(true)
		} else if((resp && resp.action) == 'TOAST_ERROR') {
			console.log('Toast error')
			global.trigger_alert("error", resp.message)
		}else if(err.message && err.message.includes("Network")){
			err.name = "Network Error : " + err.name 
			Sentry.configureScope(scope => {
				scope.setTag("request_id", headers ? headers['x-request-id'] : '');
			});
			Sentry.captureMessage(err.message, {fingerprint: ["Network Error"]})
            window.trigger_alert("error", "Network Issue! Please check your network and try again.")
			return new NetworkError(err.message, url, resp)
		} else {
			if(err.constructor.name.includes("Error") != true) err=new Error(err)
			console.error("Captured error in the API call " + url + (body ? ", body: "+ JSON.stringify(body) : '') + (resp ? ", response: "+ JSON.stringify(resp) : '') + ", x-request-id: " + (headers ? headers['x-request-id'] : '') + " : " + err.name);
			err.name = "Captured error in the API call " + url+ (resp ? ", response: "+ JSON.stringify(resp) : '') + " : " + err.name
			Sentry.configureScope(scope => {
				scope.setTag("request_id", headers ? headers['x-request-id'] : '');
			});
			Sentry.captureException(err);
		}
		return Promise.reject({ err, resp,info: 'Error in general_fetch' })
	}
} 

window.general_fetch = general_fetch;
export default general_fetch ;
